export const initialState = {
  showSideBar: false,
  activeTab: "",
  activeFooterTab: "",
  // When true, the global <Header/> is hidden below md (mobile). Set by a
  // pushed screen's PageHeader (mobileHeader) so mobile shows ONE yellow
  // back-header (RN HomeHeader parity) instead of the global header + a
  // second page header (the "double chrome").
  hideGlobalHeaderMobile: false,
};
